module.exports = require('./helpers/bundle-url').getBundleURL('fp6dw') + "logo-dark.eefe0b7f.svg";